import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { NumberHelper } from "../../../../../../../utilities/contracts/number-helper";
import { RiskService } from "../../../../chase-detail/chase-detail-chart/risk/risk.service";
import { RiskError } from "./risk-validation.model";

@Component({
  selector: "member-risk-validation-modal",
  templateUrl: "./risk-validation-modal.component.html",
  styleUrls: ["./risk-validation-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskValidationModalComponent implements OnInit, OnDestroy {
  private unsubscribe = new Subject();
  visible = false;
  errors: RiskError[];

  constructor(
    private riskService: RiskService,
    private changeDetector: ChangeDetectorRef,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.riskService.data
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(state => {
        this.visible = state.hasErrors;
        this.errors = state.hasErrors ? state.errors : [];
        this.changeDetector.markForCheck();
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


  getDisplayText(error: RiskError): string {
    return error.message;
  }

  gotoError(error: RiskError): void {
    const selectedIndexes = this.getIndexes(error);
    this.riskService.setData(selectedIndexes);
    setTimeout(() => {
      this.router.navigate(["../encounter"], { relativeTo: this.activatedRoute });
    });
  }

  clearErrors(): void {
    this.riskService.setData({ errors: [] });
  }

  private getIndexes(error: RiskError): { selectedEncounterIndex: number; selectedDiagnosisIndex: number } {
    const encounterEntityId = error.hasParent ? error.parentEntityId : error.entityId;
    const selectedEncounterIndex = this.riskService.data.value.encounters.findIndex(encounter => encounter.entityId === encounterEntityId);

    if (!NumberHelper.isBetween(selectedEncounterIndex, 0, this.riskService.data.value.encounters.length, "[)")) {
      throw new Error(`The index found for error '${error.message}' is invalid.`);
    }

    const selectedDiagnosisIndex = error.hasParent ?
      this.riskService.data.value.encounters[selectedEncounterIndex].diagnoses.findIndex(diagnosis => diagnosis.entityId === error.entityId) :
      null;

    return { selectedEncounterIndex, selectedDiagnosisIndex };
  }

  trackByIndex(index, item) {
    return index;
  }
}
